export default __webpack_public_path__ + "static/media/Highlord's Mace.be355246.jpg";